import { API } from '~apis/axios/instance';
import { ResponseBase } from '~types/response';

interface Response extends ResponseBase {
  data: {
    id: string;
    email: string;
  };
}

/**
 * 유저 상세 조회
 */
export default function getUser(userId: string) {
  return API.get<Response>(`/api/v3/users/${userId}`);
}
